'use strict';

/* global angular */

const IntercomService = require('./IntercomService');

const intercom = angular.module('common.intercom', [
  'common.auth',
  'common.identity'
]);

intercom.service('IntercomService', [
  '$document',
  '$timeout',
  'AppDialogsActions',
  'AuthService',
  'sbFlux',
  'IdentityService',
  IntercomService
]);

intercom.run(['IntercomService', (IntercomService) => {

  IntercomService.init();
}]);



// WEBPACK FOOTER //
// ./src/common/intercom/index.js